import { useMemo } from "react";
import { useRecords } from "../../../api/useRecords";
import { ReservedSlot } from "../types";

const RESERVED_SLOTS_ENTITY = "reserved_slots";

export const useReservedSlotsByServiceProvided = (serviceProvidedIds: Array<number>) => {
    const { data: reservedSlotsResponse, isLoading } = useRecords(
        RESERVED_SLOTS_ENTITY,
        "*,therapist.*",
        {
            extraOptions: {
                filter: {
                    services_provided: { _in: serviceProvidedIds },
                },
            },
            enabled: serviceProvidedIds.length > 0,
        }
    );

    const reservedSlotsByServiceProvided = useMemo(() => {
        const reservedSlots = (reservedSlotsResponse?.items ?? []) as Array<ReservedSlot & { services_provided: number }>;
        const groupedByServiceProvided: Record<number, Array<ReservedSlot>> = {};

        reservedSlots.forEach((slot) => {
            const serviceProvidedId = slot.services_provided;
            if (!groupedByServiceProvided[serviceProvidedId]) {
                groupedByServiceProvided[serviceProvidedId] = [];
            }
            groupedByServiceProvided[serviceProvidedId].push(slot);
        });

        return groupedByServiceProvided;
    }, [reservedSlotsResponse]);

    return { reservedSlotsByServiceProvided, isLoading };
};

